import {
  MY_SCAN_LIST,
  SELECTED_SCAN_ITEM,
  SELECTED_SCAN_LINKED_ITEM
} from '../actions';

export const myScanReducer = (state = {}, action) => {
  if (action.type == MY_SCAN_LIST) return action.payload;
  return state;
};

export const selectedScanItemReducer = (state = {}, action) => {
  if (action.type == SELECTED_SCAN_ITEM) return action.payload;
  return state;
};

export const selectedScanLinkedItemReducer = (state = {}, action) => {
  if (action.type == SELECTED_SCAN_LINKED_ITEM) return action.payload;
  return state;
};
